import { gql } from 'apollo-boost'
import client from 'apollo/Apollo'
import { openDialog } from 'ducks/dialogSlice'
import { updateRegion } from 'ducks/entitiesSlice'

const UPDATE_REGION = gql`
  mutation updateRegion($id: Int, $name: String) {
    updateRegion(id: $id, name: $name) {
      regionID
    }
  }
`
export const saveRegion = (region, regionIndex) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: UPDATE_REGION,
        variables: {
          id: region.regionID,
          name: region.regionName,
        },
      })

      let updatedRegion = { ...region, dirty: false }
      dispatch(updateRegion({ index: regionIndex, updatedRegion }))
    } catch (error) {
      // this function is declared in the index file for application monitoring
      // eslint-disable-next-line no-undef
      ineum('reportError', error)      
      dispatch(
        openDialog({
          type: 'error',
          title: `System Error`,
          props: {
            error,
          },
        })
      )
    }
  }
}
